export const BrandAccentHorizontalSvg = () => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: purely decorative, no need for title
  <svg width="206" height="42" viewBox="0 0 206 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.95099 41.4824C2.67103 41.4824 0.822748 39.6342 0.82272 37.3542L0.822296 2.00039C0.822282 0.791986 2.03553 -0.039754 3.16264 0.395969L102.379 38.7514C102.778 38.9057 103.221 38.9057 103.62 38.7514L202.836 0.395955C203.964 -0.0397648 205.177 0.791961 205.177 2.00036L205.177 37.3542C205.177 39.6341 203.328 41.4824 201.048 41.4824L4.95099 41.4824Z"
      fill="currentColor"
    />
  </svg>
);
